import {CTA, ExternalLinkIndicator} from '@volkswagen-onehub/components-core';
import {LinkProps} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import * as React from 'react';

export function Link(props: LinkProps): JSX.Element {
  const {
    children,
    icon,
    iconPosition,
    ariaLabel,
    tabIndex,
    href,
    initialFocus,
    target,
    rel,
    title,
  } = props;
  return (
    <CTA
      icon={icon}
      iconPosition={iconPosition}
      aria-label={ariaLabel}
      tabIndex={tabIndex}
      href={href}
      target={target}
      rel={rel}
      title={title}
      data-autofocus-inside={initialFocus ? 'true' : undefined}
      tag="a"
      emphasis="tertiary"
    >
      {children}
      {props.external && <ExternalLinkIndicator />}
    </CTA>
  );
}
